import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
export default [{
  path: '/home/appointment-event',
  name: 'AppointmentEvent',
  props: function props(route) {
    return route.query;
  },
  component: function component() {
    return import('@/pages/home/appointment/event');
  },
  meta: {
    name: i18n.tc("129")
  }
}, {
  path: '/event/detail/:eventId',
  name: 'EventDetail',
  props: true,
  component: function component() {
    return import('@/pages/event/detail');
  },
  meta: {
    name: i18n.tc("130")
  }
}, {
  path: '/event/detail/comment/:eventId',
  name: 'EventDetailComment',
  props: function props(route) {
    return {
      eventId: route.params.eventId,
      anonymity: 1
    };
  },
  component: function component() {
    return import('@/pages/event/detail/EventBottomOptions/GeneralEvaluate');
  },
  meta: {
    name: i18n.tc("131")
  }
}];